module.exports = __webpack_public_path__ + "img/rjbx.658b1b8f.png";